import React, { useState } from "react";

export const FAQS = [
  {
    q: "What exactly is roof rejuvenation?",
    a: "It's a spray-applied, plant-based bio-oil treatment that soaks into aging asphalt shingles and restores the flexibility and granule adhesion they had when new. Each treatment adds up to five years of roof life and can be repeated — up to fifteen extra years in total.",
  },
  {
    q: "How do I know if my roof qualifies?",
    a: "Most asphalt shingle roofs between roughly 6 and 20 years old are strong candidates. We perform a free on-site inspection and give you an honest recommendation: rejuvenate, repair, or — only when it's truly needed — replace.",
  },
  {
    q: "How much does rejuvenation cost compared to replacement?",
    a: "Rejuvenation runs $2.50 per square foot — typically about half the cost of a full tear-off and replacement. On an average New Jersey home, that means saving thousands of dollars while getting years more life from the roof you already have.",
  },
  {
    q: "How long does the treatment take?",
    a: "Most homes are done in a single visit — usually just a few hours. No dumpsters, no tear-off debris, no days of hammering over your head.",
  },
  {
    q: "Is the treatment safe for my family, pets, and landscaping?",
    a: "Yes. The treatment is a plant-based, food-grade bio-oil that is safe for people, pets, gardens, and gutters. It's also the eco-friendly choice — every rejuvenated roof keeps roughly three tons of shingles out of a landfill.",
  },
  {
    q: "Do you handle roof repairs too?",
    a: "We do. Missing shingles, flashing failures, leaks, and storm damage are repaired by the same craftsmen who build our custom homes — and if we find damage during a rejuvenation inspection, we'll fix it before treating.",
  },
];

export default function RoofingFAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      data-testid="roofing-faq-section"
      className="relative py-28 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4 reveal">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline w-10" />
              <span className="eyebrow">Roofing FAQ</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-[1.05] tracking-tight text-[var(--text-primary)] mb-8">
              Questions,
              <br />
              <em className="text-[var(--accent)]">answered.</em>
            </h2>
            <p className="text-[var(--text-secondary)] leading-relaxed mb-8">
              Everything homeowners ask us about roof rejuvenation and repair.
              Still curious? We'll answer in person — the inspection is free.
            </p>
            <a href="#contact" className="btn-outline w-fit" data-testid="faq-cta">
              Ask Us Directly
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-white/10">
              {FAQS.map((f, i) => (
                <div
                  key={i}
                  className="reveal border-b border-white/10"
                  style={{ transitionDelay: `${i * 60}ms` }}
                >
                  <button
                    onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
                    data-testid={`faq-question-${i}`}
                    aria-expanded={openIdx === i}
                  >
                    <span className="flex items-baseline gap-5">
                      <span className="num-marker text-lg shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display text-xl md:text-2xl text-[var(--text-primary)] group-hover:text-[var(--accent)] transition-colors duration-300">
                        {f.q}
                      </span>
                    </span>
                    <svg
                      className={`shrink-0 text-[var(--accent)] transition-transform duration-300 ${
                        openIdx === i ? "rotate-45" : ""
                      }`}
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                    >
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                  </button>
                  <div
                    className={`overflow-hidden transition-[max-height,opacity] duration-500 ${
                      openIdx === i ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                    }`}
                    data-testid={`faq-answer-${i}`}
                  >
                    <p className="pb-7 pl-0 md:pl-12 pr-4 text-[var(--text-secondary)] leading-relaxed max-w-3xl">
                      {f.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
